export const TOGGLE_LINK_CONSTANTS = {
	defaultToggledText: 'View Less',
	defaultUnToggledText: 'View More'
};
